<div class="container">
  <span class="tag tag-success" *ngIf="usuarioPodeAcessarTodasUnidades" title="Você possui acesso para visualizar todas as unidades.">Acessa todas as unidades</span>
  <span class="tag tag-warning" *ngIf="!usuarioPodeAcessarTodasUnidades" title="Seu perfil é restrito a visualizar sua unidade.">Restrito a sua unidade</span>
</div>
